import { typedQuery } from "../../../typed-query";
import type { EventHub, EventHubSeo } from "./types";

export const eventHubSeoQuery = typedQuery<EventHubSeo>(`
*[_type == "finAIEventHub" && eventSeries == $eventSeries][0]{
  seo {
    title,
    description,
    "image": image.asset->url
  }
}`);

const eventHubListingFragment = `
  _id,
  title,
  description,
  labels,
  href,
  virtualHref,
  topics[]->{
    _id,
    title,
    "slug": slug.current
  },
  thumbnail {
    small {
      "src": asset->url,
      "alt": asset->altText,
      "width": asset->metadata.dimensions.width,
      "height": asset->metadata.dimensions.height
    },
    large {
      "src": asset->url,
      "alt": asset->altText,
      "width": asset->metadata.dimensions.width,
      "height": asset->metadata.dimensions.height
    }
  },
  hasEventPage,
  eventPage->{
    _id,
    "slug": path.current
  }
`;

/**
 * @returns the event hub for the given event series
 */
export const eventHubQuery = typedQuery<EventHub>(`
*[_type == "finAIEventHub" && eventSeries == $eventSeries][0]{
  _id,
  eventSeries,
  eventReference->{
    _id,
    title,
    lifecycleStatus,
    series,
    attendanceType,
    timings,
    "city": location.address.city,
    "country": location.address.country,
    "state": location.address.state
  },
  hero {
    title,
    description,
    primaryCta {
      label,
      href
    },
    secondaryCta {
      label,
      href
    }
  },
  featuredListing->{
    ${eventHubListingFragment}
  },
  listings[]->{
    ${eventHubListingFragment}
  }
}`);
